import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import SeoMappersFactory from '../Mappers/factory.js'
import {FromRemoteSeoContentToSeoResponseSeoMapper} from '../Mappers/FromRemoteSeoContentToSeoResponseSeoMapper.js'
import {SeoRepositoriesFactory} from '../Repositories/factory.js'
import SeoValueObjectsFactory from '../ValueObjects/factory.js'
import {GetSeoDataService} from './GetSeoDataService.js'

export class GetRemoteSeoDataSeoService extends Service {
  #getSeoDataService
  #httpSeoRepository
  #fromRemoteSeoContentToSeoResponseSeoMapper
  #seoDataValueObjectFactory

  constructor({
    getSeoDataService,
    httpSeoRepository,
    fromRemoteSeoContentToSeoResponseSeoMapper,
    seoDataValueObjectFactory
  }) {
    super()
    this.#getSeoDataService = getSeoDataService
    this.#httpSeoRepository = httpSeoRepository
    this.#fromRemoteSeoContentToSeoResponseSeoMapper = fromRemoteSeoContentToSeoResponseSeoMapper
    this.#seoDataValueObjectFactory = seoDataValueObjectFactory
  }

  static create({config}) {
    return new GetRemoteSeoDataSeoService({
      getSeoDataService: new GetSeoDataService({
        config,
        mapperFactory: SeoMappersFactory.seoMetaInformationMapper({config})
      }),
      httpSeoRepository: SeoRepositoriesFactory.hTTPSeoRepository({config}),
      fromRemoteSeoContentToSeoResponseSeoMapper: new FromRemoteSeoContentToSeoResponseSeoMapper({
        seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
      }),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })
  }

  @AsyncInlineError()
  async execute({seoDataRequestVO, canonicalUrl, vehicleCount}) {
    if (!canonicalUrl) {
      const [localError, localResponse] = await this.#getSeoDataService.execute({seoDataRequestVO})
      if (localError) return Promise.reject(localError)
      return localResponse
    }

    const [localSeoDataResult, remoteSeoContentResult] = await Promise.all([
      this.#getSeoDataService.execute({seoDataRequestVO}),
      this.#httpSeoRepository.getRemoteSeoContent({canonicalUrl, vehicleCount})
    ])

    const [localSeoDataError, localSeoDataResponse] = localSeoDataResult
    const [remoteSeoContentError, remoteSeoContent] = remoteSeoContentResult

    if (localSeoDataError) return Promise.reject(localSeoDataError)

    if (remoteSeoContentError || !remoteSeoContent || !remoteSeoContent.isComplete()) {
      return localSeoDataResponse
    }

    return this.#fromRemoteSeoContentToSeoResponseSeoMapper.map({
      localSeoDataResponse,
      remoteSeoContent
    })
  }
}
